import { render, staticRenderFns } from "./SeriesArticles.vue?vue&type=template&id=56e3bc4f&scoped=true&"
import script from "./SeriesArticles.vue?vue&type=script&lang=js&"
export * from "./SeriesArticles.vue?vue&type=script&lang=js&"
import style0 from "./SeriesArticles.vue?vue&type=style&index=0&id=56e3bc4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3bc4f",
  null
  
)

export default component.exports